"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.MessageInline = void 0;
require("./MessageInline.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _textColorOptions = require("../../../.storybook/util/textColorOptions");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * MessageInline component
 *
 * @method
 * @param { MessageInlineProps} props
 * @returns MessageInline
 */
/**
 * Primary UI component for MessageInline
 */

const MessageInline = props => {
  const {
    message,
    iconName,
    variant = defaultProps.variant,
    textColor
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-MessageInline', {
    [`pal-c-MessageInline__color--${textColor || variant}`]: variant
  });
  const getIconName = () => {
    switch (variant) {
      case 'error':
        return 'exclamationTriangle';
      case 'info':
        return 'infoCircle';
      case 'success':
        return 'check';
      case 'warning':
        return 'exclamationTriangle';
      default:
        return 'exclamationTriangle';
    }
  };
  const derivedIcon = variant !== 'unstyled' ? getIconName() : iconName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, derivedIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: derivedIcon,
    size: "lg"
  }), message && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textColor: textColor || variant
  }, message));
};

/**
 * Property type definitions
 * @typedef MessageInlineProps
 * @type {object}
 * @property {string} [message] - Message to display.
 * @property {string} [iconName] - Optional. Name of the icon to show above the headline.
 * @property {string} [variant] - Variant for message ('error', 'info', 'success', 'warning','unstyled').
 * @property {string} [textColor] - (Optional) Override for custom style color.
 */
exports.MessageInline = MessageInline;
const propTypes = exports.propTypes = {
  /**
   * Icon name to display above the headline
   */
  iconName: _propTypes.default.string,
  /**
   * Message to display
   */
  message: _propTypes.default.string,
  /**
   * Color for message ('error', 'info', 'success', 'warning','unstyled')
   */
  variant: _propTypes.default.string,
  /**
     * Optional color overrides
     * - **default:** sets the color to default
     * - **default-disabled:** sets the color to default-disabled
     * - **subtle:** sets the color to subtle
     * - **xsubtle:** sets the color to xsubtle
     * - **brand-01:** sets the color to brand-01
     * - **brand-02:** sets the color to brand-02
     * - **brand-02-strong:** sets the color to brand-02-strong
     * - **brand-03:** sets the color to brand-03
     * - **brand-04:** sets the color to brand-04
     * - **knockout:** sets the color to knockout
     * - **validation:** sets the color to validation
     * - **notification:** sets the color to notification
     */
  textColor: _propTypes.default.oneOf(_textColorOptions.textColorOptions)
};
const defaultProps = exports.defaultProps = {
  variant: 'error'
};
MessageInline.propTypes = propTypes;
var _default = exports.default = MessageInline;